<script setup lang="ts">
import { SolButton, SolDivider } from '@solfacil/girassol'
import { PaymentModelStatus } from '~/constants/receiptModel'
import StatusDates from '~/ui-blocks/Formalization/StatusDates.vue'

const { isComboStoreOrder, stepStatus } = defineProps<{
  showDates: boolean
  submittedAt?: string
  completedAt?: string
  reprovedAt?: string
  loading: boolean
  disabled: boolean
  isComboStoreOrder: boolean
  stepStatus: string | null
}>()

const emit = defineEmits<{
  submit: []
}>()

const { t } = useI18n()

const buttonLabel = computed(() => {
  if (isComboStoreOrder)
    return t('app.confirm')

  if (stepStatus === PaymentModelStatus.TO_REVIEW)
    return t('receipt-model.layout.resend_for_analysis')

  return t('app.send_for_analysis')
})
</script>

<template>
  <div>
    <SolDivider thickness="x-small" orientation="horizontal" class="mt-8 mb-6" />

    <div :class="`flex ${showDates ? 'justify-between' : 'justify-end'} w-full gap-3 sm:system:items-center flex-col sm:system:flex-row`">
      <StatusDates
        v-if="showDates"
        :submitted-at="submittedAt"
        :completed-at="completedAt"
        :reproved-at="reprovedAt"
      />
      <SolButton
        id="check_payment_mode_information"
        size="large"
        :loading="loading"
        :disabled="disabled"
        @click="emit('submit')"
      >
        {{ buttonLabel }}
      </SolButton>
    </div>
  </div>
</template>
